import React, { useState } from 'react';
import { Download, Loader } from 'lucide-react';
import { billingService, PaymentFilters } from '../../../services/billingService';
import { showToast } from '../../../components/Toast';

interface ExportButtonProps {
  filters: PaymentFilters;
}

const ExportButton: React.FC<ExportButtonProps> = ({ filters }) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);

      const csvContent = await billingService.exportPaymentsToCSV(filters);

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const timestamp = new Date().toISOString().split('T')[0];

      link.setAttribute('href', url);
      link.setAttribute('download', `payment-history-${timestamp}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
      showToast('Failed to export payment history', 'error');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className="inline-flex items-center gap-2 bg-[#23F47C] text-gray-900 px-6 py-2 rounded-lg font-semibold hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all whitespace-nowrap"
    >
      {isExporting ? (
        <>
          <Loader size={18} className="animate-spin" />
          Exporting...
        </>
      ) : (
        <>
          <Download size={18} />
          Export CSV
        </>
      )}
    </button>
  );
};

export default ExportButton;
